import Info from 'components/ProductPage/Info/Info';

export default Info;
